import { FeedbotMiddleware, isThunk } from '../types'
import { botFlowSelector } from './selectors/botFlowSelector'
import { latestVersionFlowSelector } from '../../features/serverBots/selectors'
import { tryToApplyDiff } from './applyDiffService'

export const botIntegrityMiddleware: FeedbotMiddleware =
  ({ dispatch, getState }) =>
  next =>
  action => {
    if (isThunk(action)) {
      return next(action)
    }

    const result = next(action)

    const nextFlow = botFlowSelector(getState())
    const nextOriginalVersionFlow = latestVersionFlowSelector(getState())

    if (nextOriginalVersionFlow && nextOriginalVersionFlow.version !== nextFlow?.version) {
      tryToApplyDiff(getState(), dispatch)
    }

    return result
  }
